<canvas baseChart
        [class.empty]="empty"
        [datasets]="[resultToChart]"
        [labels]="doughnutLabels"
        [options]="config.doughnutChartOptions"
        [colors]="chartColors"
        [chartType]="config.doughnutChartType"></canvas>
<cc-empty-chart
  [empty]="empty"
></cc-empty-chart>
